import React from 'react'
import kanekt365CounterBg from '../assets/kanekt365CounterBg.jpg'
import { Divider } from '@mui/material'
import { Link } from 'react-router-dom'
import CountUp from 'react-countup'

const CounterSection = () => {
    const Icon0 = () =>(
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" className='max-w-12'
        viewBox="0 0 512.000000 512.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="#0773b3" stroke="none">
        <path d="M2780 4945 c-245 -39 -500 -180 -659 -365 -192 -223 -281 -468 -281
        -777 l0 -123 -118 0 c-159 0 -208 -15 -278 -84 -80 -80 -84 -103 -84 -436 0
        -332 5 -356 83 -434 56 -56 126 -86 198 -86 l39 0 0 -175 c0 -238 -13 -225
        227 -225 l178 -1 118 -114 117 -114 0 -135 0 -135 -69 -21 c-37 -11 -73 -20
        -79 -20 -6 0 -11 47 -13 123 -5 140 -20 177 -92 225 l-41 27 -906 0 -906 0
        -41 -27 c-22 -15 -51 -44 -64 -65 l-24 -38 0 -665 0 -665 24 -38 c13 -21 42
        -50 64 -65 l40 -27 240 -3 239 -3 -6 -22 c-3 -12 -11 -48 -17 -80 l-12 -57
        -104 0 c-97 0 -106 -2 -128 -25 -33 -32 -33 -78 0 -110 l24 -25 2271 0 2271 0
        25 25 26 26 -4 297 c-4 266 -7 305 -26 376 -75 274 -279 501 -537 599 -38 15
        -221 70 -405 123 -184 52 -365 104 -402 115 l-68 20 0 137 1 137 72 65 c171
        153 297 333 353 502 l19 56 155 4 c139 3 160 6 200 27 61 32 97 67 128 126
        l27 50 3 294 c4 351 0 374 -84 458 -67 68 -118 83 -276 83 l-118 0 0 118 c0
        218 -38 382 -130 561 -160 311 -470 534 -817 586 -118 18 -239 18 -353 0z
        m343 -160 c372 -65 668 -339 769 -714 17 -62 22 -116 25 -290 l5 -213 -23 7
        c-54 17 -180 89 -240 138 -35 30 -86 83 -114 120 -79 104 -78 103 -263 14
        -374 -179 -767 -283 -1184 -312 l-98 -7 0 195 c0 293 34 442 142 617 206 335
        597 512 981 445z m362 -1126 c113 -114 223 -185 373 -239 l63 -23 -3 -321 c-4
        -295 -6 -327 -26 -394 -84 -278 -326 -542 -624 -682 -99 -46 -229 -80 -308
        -80 -169 0 -433 120 -605 274 l-50 45 178 1 c154 0 177 -2 177 -16 0 -27 101
        -119 146 -132 53 -16 255 -16 308 0 86 26 166 136 166 228 0 92 -72 195 -157
        224 -57 20 -256 22 -317 4 -45 -13 -146 -105 -146 -132 0 -14 -30 -16 -247
        -16 l-248 0 -26 43 c-47 74 -88 163 -111 239 -20 67 -22 99 -26 380 l-4 306
        89 7 c239 17 428 46 624 95 219 55 472 145 624 223 39 20 72 36 75 37 3 0 37
        -32 75 -71z m-1645 -499 l0 -360 -40 0 -40 0 0 360 0 360 40 0 40 0 0 -360z
        m2320 0 l0 -360 -40 0 -40 0 0 360 0 360 40 0 40 0 0 -360z m-2560 0 c0 -192
        -4 -350 -8 -350 -5 0 -21 14 -38 31 l-29 30 0 289 0 289 29 30 c17 17 33 31
        38 31 4 0 8 -157 8 -350z m2766 319 l29 -30 0 -289 0 -289 -29 -30 c-17 -17
        -33 -31 -38 -31 -4 0 -8 158 -8 350 0 193 4 350 8 350 5 0 21 -14 38 -31z
        m-2472 -896 c10 -32 31 -84 47 -115 16 -32 29 -60 29 -63 0 -3 -29 -5 -65 -5
        l-65 0 0 120 c0 109 2 120 18 120 14 0 23 -15 36 -57z m1201 -208 c16 -15 25
        -36 25 -55 0 -19 -9 -40 -25 -55 -23 -24 -31 -25 -135 -25 -104 0 -112 1 -135
        25 -16 15 -25 36 -25 55 0 19 9 40 25 55 23 24 31 25 135 25 104 0 112 -1 135
        -25z m-1107 -467 c17 -17 17 -1239 0 -1256 -9 -9 -77 -12 -244 -12 l-231 0
        -39 178 c-30 136 -44 182 -61 200 -22 22 -25 22 -293 22 -268 0 -271 0 -293
        -23 -17 -17 -31 -63 -61 -199 l-39 -178 -231 0 c-167 0 -235 3 -244 12 -17 17
        -17 1239 0 1256 17 17 1719 17 1736 0z m757 -114 c77 -23 108 -27 215 -27 107
        0 138 4 215 27 50 15 129 47 178 70 l87 43 0 -99 0 -98 -236 -270 c-130 -149
        -240 -270 -244 -270 -4 0 -114 121 -244 270 l-236 270 0 98 0 99 88 -43 c48
        -23 128 -55 177 -70z m-141 -469 l227 -259 -156 -79 c-87 -43 -160 -76 -162
        -73 -9 8 -323 608 -323 616 0 6 169 59 181 56 3 0 108 -118 233 -261z m1059
        231 c38 -12 68 -25 68 -31 -1 -20 -316 -615 -326 -614 -5 0 -79 35 -163 77
        l-153 78 228 261 c206 236 230 261 253 256 14 -4 56 -16 93 -27z m782 -232
        c145 -60 284 -192 358 -339 61 -123 70 -171 75 -427 l4 -238 -201 0 -201 0 0
        135 c0 131 -1 137 -25 160 -32 33 -78 33 -110 0 -24 -23 -25 -29 -25 -160 l0
        -135 -528 0 -527 0 -29 77 -29 77 72 143 71 143 40 -20 c51 -26 73 -25 104 3
        13 12 95 157 181 322 87 165 173 328 191 361 l34 62 252 -73 c139 -41 271 -81
        293 -91z m-2013 -586 c24 -22 64 -23 98 -3 14 8 30 14 35 15 6 0 41 -62 79
        -138 l69 -139 -25 -74 -25 -74 -540 -3 -540 -2 -12 57 c-6 32 -14 68 -17 80
        l-6 22 239 3 c230 3 239 4 276 27 21 13 50 42 65 64 l27 40 3 311 3 310 125
        -239 c69 -132 135 -248 146 -257z m648 152 c66 -33 120 -62 120 -65 0 -3 -29
        -64 -65 -135 l-65 -130 -110 0 -110 0 -65 130 c-36 71 -65 132 -65 135 0 4
        226 122 238 124 1 1 56 -26 122 -59z m-1726 -272 c31 -145 60 -271 62 -280 5
        -17 -14 -18 -296 -18 -282 0 -301 1 -296 18 2 9 31 135 62 280 l58 262 176 0
        176 0 58 -262z m1724 -251 c7 -18 12 -36 12 -40 0 -4 -58 -7 -130 -7 -99 0
        -128 3 -125 13 2 6 9 24 14 40 l11 27 103 0 103 0 12 -33z"/>
        <path d="M2415 3346 c-101 -44 -125 -178 -46 -257 112 -113 296 -12 267 146
        -18 94 -131 151 -221 111z"/>
        <path d="M3375 3346 c-101 -44 -125 -178 -46 -257 112 -113 296 -12 267 146
        -18 94 -131 151 -221 111z"/>
        <path d="M105 295 c-16 -15 -25 -36 -25 -55 0 -19 9 -40 25 -55 21 -22 33 -25
        95 -25 62 0 74 3 95 25 33 32 33 78 0 110 -21 22 -33 25 -95 25 -62 0 -74 -3
        -95 -25z"/>
        </g>
      </svg>
    )
    const Icon1 = () =>(
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" className='max-w-12'
        viewBox="0 0 512.000000 512.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="#0773b3" stroke="none"> 
        <path d="M1803 4945 c-129 -35 -246 -128 -305 -241 l-33 -64 -109 0 c-60 0
        -126 -5 -148 -12 -48 -14 -121 -76 -138 -118 l-12 -30 -346 0 c-241 0 -357 -4
        -386 -12 -55 -16 -138 -99 -154 -154 -18 -60 -18 -3928 0 -3988 16 -55 99
        -138 154 -154 32 -9 405 -12 1600 -12 1547 0 1559 1 1604 21 25 11 57 32 72
        46 l26 25 97 -46 c54 -25 106 -46 115 -46 10 0 81 30 157 66 76 36 163 77 193
        91 226 104 462 227 505 263 109 92 188 210 236 355 24 70 24 71 27 702 l3 633
        -23 23 c-22 22 -34 24 -163 30 -149 6 -233 20 -358 61 -142 47 -244 106 -436
        250 -77 58 -123 86 -141 86 -17 0 -52 -19 -94 -50 l-66 -51 0 827 c0 620 -3
        837 -12 868 -16 55 -99 138 -154 154 -29 8 -145 12 -386 12 l-346 0 -12 30
        c-17 42 -90 104 -138 118 -22 7 -88 12 -148 12 l-109 0 -33 65 c-39 73 -133
        167 -203 202 -103 51 -232 66 -336 38z m214 -161 c103 -35 174 -108 209 -213
        29 -89 34 -91 211 -91 150 0 155 -1 178 -25 25 -24 25 -27 25 -200 l0 -175
        -720 0 -720 0 0 175 c0 173 0 176 25 200 23 24 28 25 178 25 178 0 183 2 211
        92 54 171 239 268 403 212z m-977 -544 l0 -80 -255 0 -256 0 -24 -25 -25 -24
        0 -1791 0 -1791 25 -24 24 -25 1310 0 1310 0 156 -74 c85 -41 155 -77 155 -80
        0 -3 -695 -6 -1545 -6 l-1546 0 -24 25 -25 24 0 1951 0 1951 25 24 24 25 336
        0 335 0 0 -80z m2455 55 l25 -24 0 -884 0 -885 -80 -41 -80 -42 0 846 0 846
        -25 24 -24 25 -256 0 -255 0 0 80 0 80 335 0 336 0 24 -25z m-2455 -310 c0 -9
        11 -27 25 -40 l24 -25 831 0 831 0 24 25 c14 13 25 31 25 40 0 13 26 15 200
        15 l200 0 0 -818 0 -819 -52 -11 c-95 -21 -191 -32 -286 -32 -85 0 -95 -2
        -117 -25 -24 -23 -25 -29 -25 -160 l0 -135 -680 0 -680 0 0 -80 0 -80 680 0
        680 0 0 -160 0 -160 -680 0 -680 0 0 -80 0 -80 680 0 679 0 3 -160 3 -160
        -682 0 -683 0 0 -80 0 -80 703 0 702 0 35 -68 c19 -37 54 -91 77 -119 l43 -53
        -1140 0 -1140 0 0 1680 0 1680 200 0 c174 0 200 -2 200 -15z m2906 -1524 c242
        -180 459 -267 732 -293 l122 -12 0 -541 c0 -602 -1 -612 -67 -739 -22 -42 -62
        -96 -98 -132 -68 -68 -103 -87 -528 -288 l-267 -127 -342 163 c-189 90 -368
        182 -400 205 -62 46 -121 119 -162 200 -54 108 -56 132 -56 719 l0 541 91 7
        c180 14 367 64 519 141 72 36 215 130 295 194 28 22 51 40 52 40 2 1 50 -34
        109 -78z"/>
        <path d="M1840 4707 c-49 -16 -133 -102 -148 -153 -28 -94 -8 -169 63 -239 51
        -52 102 -75 165 -75 63 0 114 23 165 75 98 97 101 222 8 325 -65 72 -158 97
        -253 67z m135 -172 c50 -49 15 -135 -55 -135 -41 0 -80 39 -80 80 0 41 39 80
        80 80 19 0 40 -9 55 -25z"/>
        <path d="M1705 3735 c-24 -23 -25 -29 -25 -160 l0 -135 -135 0 c-131 0 -137
        -1 -160 -25 -25 -24 -25 -26 -25 -215 0 -189 0 -191 25 -215 23 -24 29 -25
        160 -25 l135 0 0 -135 c0 -131 1 -137 25 -160 24 -25 26 -25 215 -25 189 0
        191 0 215 25 24 23 25 29 25 160 l0 135 135 0 c131 0 137 1 160 25 25 24 25
        26 25 215 0 189 0 191 -25 215 -23 24 -29 25 -160 25 l-135 0 0 135 c0 131 -1
        137 -25 160 -24 25 -26 25 -215 25 -189 0 -191 0 -215 -25z m295 -270 c0 -131
        1 -137 25 -160 23 -24 29 -25 160 -25 l135 0 0 -80 0 -80 -135 0 c-131 0 -137
        -1 -160 -25 -24 -23 -25 -29 -25 -160 l0 -135 -80 0 -80 0 0 135 c0 131 -1
        137 -25 160 -23 24 -29 25 -160 25 l-135 0 0 80 0 80 135 0 c131 0 137 1 160
        25 24 23 25 29 25 160 l0 135 80 0 80 0 0 -135z"/>
        <path d="M880 2400 l0 -80 160 0 160 0 0 80 0 80 -160 0 -160 0 0 -80z"/>
        <path d="M1360 2400 l0 -80 600 0 600 0 0 80 0 80 -600 0 -600 0 0 -80z"/>
        <path d="M880 1920 l0 -80 160 0 160 0 0 80 0 80 -160 0 -160 0 0 -80z"/>
        <path d="M880 1440 l0 -80 160 0 160 0 0 80 0 80 -160 0 -160 0 0 -80z"/>
        <path d="M880 960 l0 -80 160 0 160 0 0 80 0 80 -160 0 -160 0 0 -80z"/>
        <path d="M3779 2294 c-75 -56 -222 -137 -325 -179 -90 -37 -190 -65 -351 -100
        -12 -3 -32 -15 -43 -27 -19 -21 -20 -34 -20 -458 0 -473 3 -505 56 -596 54
        -91 108 -127 424 -277 162 -77 306 -140 320 -140 14 0 158 63 320 139 276 130
        299 143 355 199 62 61 97 121 115 197 5 25 10 228 10 479 0 422 -1 436 -20
        457 -11 12 -37 25 -58 30 -183 43 -240 59 -327 93 -106 42 -224 107 -314 170
        -64 46 -94 48 -142 13z m128 -195 c143 -90 342 -172 531 -219 l43 -11 -3 -402
        c-3 -361 -5 -405 -21 -434 -36 -67 -82 -96 -344 -221 -142 -67 -265 -122 -272
        -122 -7 0 -130 55 -273 123 -284 133 -324 161 -352 244 -14 39 -16 107 -16
        429 l0 383 43 11 c104 27 157 43 222 67 82 31 261 120 325 162 25 16 47 30 49
        30 2 1 33 -17 68 -40z"/>
        <path d="M3968 1443 l-288 -288 -88 88 c-48 48 -92 87 -98 87 -13 0 -104 -93
        -104 -106 0 -5 58 -67 128 -137 114 -112 133 -127 163 -127 31 0 60 27 361
        327 180 180 328 332 328 338 0 13 -92 105 -105 105 -6 0 -139 -129 -297 -287z"/>
        </g>
      </svg>
    )
    const Icon2 = () =>(
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" className='max-w-12'
        viewBox="0 0 512.000000 512.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="#0773b3" stroke="none">
        <path d="M920 5090 c-385 -82 -706 -366 -829 -735 -139 -415 -34 -856 277
        -1161 367 -361 934 -424 1374 -153 l48 29 211 -44 c117 -25 219 -42 228 -39
        32 12 51 37 51 67 0 18 -29 119 -65 226 l-65 195 34 85 c69 170 81 235 80 435
        0 162 -3 190 -27 278 -30 111 -95 255 -157 348 -129 191 -351 359 -574 435
        -166 57 -414 71 -586 34z m391 -135 c386 -67 686 -344 785 -721 21 -81 26
        -123 27 -229 1 -171 -27 -303 -94 -437 -16 -32 -29 -68 -29 -81 0 -12 23 -90
        50 -172 28 -82 50 -152 50 -155 0 -3 -76 10 -170 29 l-169 34 -85 -52 c-98
        -60 -192 -100 -296 -127 -60 -15 -108 -19 -240 -18 -149 1 -173 3 -254 28
        -317 96 -556 324 -660 630 -46 135 -61 336 -36 477 39 225 165 442 338 582
        225 183 510 260 783 212z"/>
        <path d="M674 4680 c-34 -14 -118 -114 -156 -186 -45 -88 -59 -148 -59 -249 1
        -102 20 -177 76 -290 57 -115 125 -205 245 -326 228 -231 444 -338 657 -327
        108 6 185 32 275 94 122 83 157 145 123 218 -13 28 -49 56 -168 134 -188 123
        -187 122 -237 122 -38 0 -48 -6 -109 -65 -37 -36 -71 -65 -75 -65 -17 0 -106
        69 -179 139 -74 71 -167 187 -167 208 0 5 16 25 36 44 63 59 94 109 94 149 0
        54 -204 370 -254 394 -37 17 -69 19 -102 6z m130 -279 l75 -115 -54 -58 c-104
        -112 -96 -177 38 -344 82 -101 225 -227 304 -268 37 -18 114 -21 146 -5 12 6
        45 34 74 62 l51 50 121 -78 c67 -43 121 -81 121 -86 0 -30 -151 -105 -231
        -115 -164 -19 -380 94 -584 307 -272 282 -333 527 -184 734 18 25 36 42 40 38
        4 -5 41 -59 83 -122z"/>
        <path d="M3620 5089 c-175 -20 -391 -108 -537 -218 -295 -222 -472 -583 -473
        -962 0 -53 -2 -57 -29 -69 -48 -20 -119 -99 -141 -157 -25 -68 -28 -217 -4
        -286 18 -55 87 -134 138 -162 l36 -20 0 -287 0 -288 -1112 0 c-759 0 -1125 -4
        -1152 -11 -55 -15 -120 -84 -134 -141 -16 -61 -17 -1655 -2 -1709 16 -56 51
        -101 100 -129 l45 -25 401 -3 400 -3 -15 -87 -16 -87 -334 -5 -333 -5 -19 -24
        c-17 -21 -19 -41 -19 -182 0 -181 6 -204 59 -220 25 -7 679 -9 2071 -7 1928 3
        2038 5 2095 22 209 63 368 223 419 424 15 55 16 140 14 710 l-3 647 -27 67
        c-28 70 -90 169 -127 202 -21 19 -21 21 -21 580 l0 561 36 20 c56 30 122 110
        139 168 19 65 19 199 0 264 -17 58 -83 138 -138 167 l-34 19 -7 108 c-3 60
        -13 145 -22 189 -94 500 -502 884 -997 939 -108 12 -149 12 -257 0z m325 -158
        c206 -43 370 -135 520 -293 177 -186 268 -397 282 -655 l6 -113 -52 0 c-48 0
        -51 1 -51 25 0 14 -11 37 -25 50 -23 24 -29 25 -155 25 l-130 0 0 95 c0 82 -3
        98 -20 115 -40 40 -68 28 -214 -95 l-137 -115 -530 0 -530 0 -24 -25 c-14 -13
        -25 -36 -25 -50 0 -24 -3 -25 -51 -25 l-52 0 6 113 c18 334 184 625 461 808
        210 139 477 191 721 140z m278 -1088 c15 -15 40 -19 148 -22 l130 -3 -3 -382
        -3 -381 -28 -80 c-42 -119 -100 -210 -192 -301 -69 -69 -98 -90 -186 -133
        -224 -109 -443 -110 -665 -1 -77 37 -120 67 -178 121 -42 39 -76 75 -76 80 0
        5 43 9 95 9 88 0 98 2 120 25 14 13 25 31 25 40 0 20 -19 57 -34 67 -6 4 -75
        8 -153 8 l-142 0 -16 31 c-9 16 -25 64 -36 106 -17 69 -19 112 -19 435 l0 358
        489 0 c295 0 500 4 515 10 15 5 61 39 104 76 l77 66 5 -56 c3 -34 12 -62 23
        -73z m-1363 -309 l0 -196 -93 4 c-106 4 -149 23 -180 76 -24 41 -33 134 -18
        189 24 88 83 122 214 123 l77 0 0 -196z m2010 170 c56 -32 75 -76 75 -169 0
        -142 -47 -187 -202 -193 l-93 -4 0 197 0 197 93 -4 c69 -3 102 -9 127 -24z
        m-2006 -575 c4 -39 16 -105 27 -147 10 -41 19 -79 19 -83 0 -12 -60 1 -88 18
        -48 30 -62 70 -62 181 l0 102 49 0 48 0 7 -71z m1886 -427 l0 -498 -72 25
        c-68 23 -89 25 -295 29 l-223 4 0 72 0 73 80 52 c230 150 378 395 406 670 l7
        71 48 0 49 0 0 -498z m-1945 63 c22 -8 72 -14 111 -15 l71 0 37 -56 c52 -78
        153 -175 247 -236 l79 -51 0 -74 0 -73 -190 0 -190 0 0 112 c0 94 -3 119 -21
        156 -25 51 -92 99 -151 109 l-38 6 0 68 c0 38 1 69 3 69 1 0 20 -7 42 -15z m9
        -297 c14 -20 16 -116 16 -840 0 -805 0 -818 -20 -838 -19 -19 -33 -20 -418
        -20 l-398 0 -34 191 c-30 170 -36 192 -58 210 -23 18 -42 19 -314 19 -168 0
        -297 -4 -307 -10 -26 -14 -29 -24 -65 -225 l-32 -180 -399 -3 c-360 -2 -400
        -1 -417 14 -17 16 -18 53 -18 842 0 754 1 827 17 844 15 17 67 18 1224 18
        l1208 0 15 -22z m753 -134 c44 -11 111 -17 188 -17 77 0 144 6 188 17 38 9 70
        16 73 16 2 0 4 -45 4 -99 0 -96 1 -100 26 -120 22 -17 41 -21 105 -21 44 0 79
        -3 79 -6 0 -3 -29 -128 -65 -276 -36 -149 -65 -272 -65 -274 0 -2 -155 -4
        -345 -4 -190 0 -345 2 -345 4 0 2 -29 125 -65 274 -36 148 -65 273 -65 276 0
        3 35 6 79 6 64 0 83 4 105 21 25 20 26 24 26 120 0 54 2 99 4 99 3 0 35 -7 73
        -16z m-437 -229 c0 -2 77 -324 170 -714 94 -391 170 -712 170 -715 0 -2 -87
        -6 -192 -8 -183 -3 -196 -4 -248 -29 -66 -31 -131 -94 -161 -155 -41 -85 -40
        -213 1 -295 l20 -39 -64 0 -64 0 -3 126 c-5 162 -7 164 -150 164 l-99 0 0 90
        0 90 138 0 c75 0 154 5 175 11 47 13 115 72 134 116 10 26 13 162 13 698 l0
        665 80 0 c44 0 80 -2 80 -5z m1551 -36 c129 -62 224 -182 249 -318 6 -32 10
        -284 10 -623 0 -642 -2 -661 -69 -765 -65 -101 -157 -169 -266 -197 -49 -13
        -132 -16 -477 -16 l-418 0 0 190 0 190 407 0 c364 0 408 2 425 17 17 15 18 42
        18 445 0 415 -1 429 -20 448 -26 26 -68 25 -97 -2 l-23 -21 0 -374 0 -373
        -190 0 c-104 0 -190 3 -190 6 0 3 77 325 170 715 94 390 170 712 170 715 0 4
        51 5 113 2 104 -3 117 -6 188 -39z m-621 -675 c0 -3 -38 -165 -85 -360 -47
        -195 -85 -357 -85 -359 0 -3 -61 -5 -135 -5 -74 0 -135 2 -135 5 0 2 -38 164
        -85 359 -47 195 -85 357 -85 360 0 3 137 6 305 6 168 0 305 -3 305 -6z m-2260
        -359 c0 -2 23 -132 50 -287 28 -155 50 -288 50 -295 0 -10 -66 -13 -316 -13
        -296 0 -315 1 -310 18 3 9 26 136 51 282 25 146 48 273 51 283 5 15 24 17 215
        17 115 0 209 -2 209 -5z m560 -505 l0 -90 -154 0 -154 0 -12 68 c-6 37 -14 77
        -17 90 l-5 22 171 0 171 0 0 -90z m1200 -190 l0 -190 -212 0 c-184 0 -218 3
        -253 19 -125 56 -152 209 -54 303 52 49 87 56 322 57 l197 1 0 -190z m-950
        -115 l0 -75 -1020 0 -1020 0 0 75 0 75 1020 0 1020 0 0 -75z"/>
        <path d="M3296 3539 c-24 -19 -26 -26 -26 -98 0 -89 14 -111 68 -111 54 0 72
        28 72 114 0 69 -2 76 -26 95 -15 12 -34 21 -44 21 -10 0 -29 -9 -44 -21z"/>
        <path d="M4126 3539 c-24 -19 -26 -27 -26 -93 0 -91 15 -116 70 -116 55 0 70
        25 70 116 0 66 -2 74 -26 93 -15 12 -34 21 -44 21 -10 0 -29 -9 -44 -21z"/>
        <path d="M3516 3009 c-68 -53 11 -196 143 -258 45 -21 71 -26 131 -26 100 1
        163 29 230 102 83 90 90 172 17 196 -36 12 -70 -10 -97 -62 -28 -56 -72 -84
        -139 -89 -69 -4 -117 18 -146 67 -30 51 -71 91 -93 91 -11 0 -31 -9 -46 -21z"/>
        </g>
      </svg>
    )
    const Icon3 = () =>(
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" className='max-w-12 md:max-w-14'
        viewBox="0 0 512.000000 512.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="#0773b3" stroke="none">
        <path d="M3621 5103 c-51 -18 -109 -72 -136 -128 -19 -38 -20 -62 -20 -435 0
        -386 0 -396 22 -435 12 -22 36 -54 55 -72 57 -55 98 -66 251 -71 l138 -4 -5
        -27 c-18 -87 -77 -444 -74 -451 2 -5 179 101 393 236 l390 244 117 0 c64 0
        140 5 168 11 69 15 129 62 162 128 l28 55 0 390 c0 358 -2 394 -19 431 -23 51
        -98 118 -149 133 -28 9 -211 12 -658 11 -531 0 -625 -3 -663 -16z m1304 -178
        l25 -24 0 -351 c0 -358 -2 -379 -39 -407 -11 -8 -64 -12 -165 -13 l-150 0
        -258 -161 c-142 -89 -260 -160 -262 -158 -2 2 9 75 24 162 l27 157 -224 0
        -224 0 -24 25 -25 24 0 362 c0 359 0 363 22 386 l21 23 614 0 614 0 24 -25z"/>
        <path d="M3792 4708 l3 -83 493 -3 492 -2 0 85 0 85 -495 0 -496 0 3 -82z"/>
        <path d="M3792 4378 l3 -83 328 -3 327 -2 0 85 0 85 -330 0 -331 0 3 -82z"/>
        <path d="M4620 4375 l0 -85 80 0 80 0 0 85 0 85 -80 0 -80 0 0 -85z"/>
        <path d="M2335 4864 c-103 -11 -296 -48 -392 -75 -391 -110 -733 -309 -1018
        -594 -284 -283 -480 -613 -589 -991 l-33 -117 -73 122 c-40 67 -77 124 -82
        127 -6 4 -108 -50 -137 -72 -3 -3 223 -387 278 -473 7 -10 61 18 247 129 132
        79 240 144 242 145 2 2 -70 127 -82 142 0 1 -48 -27 -106 -62 -58 -36 -108
        -65 -112 -65 -10 0 30 135 77 256 251 648 795 1129 1471 1304 334 86 719 87
        1057 0 l107 -27 24 76 c18 56 21 78 12 83 -21 12 -173 48 -293 69 -91 16 -168
        22 -338 24 -121 2 -238 1 -260 -1z"/>
        <path d="M2395 4283 c-205 -32 -417 -135 -572 -277 -138 -127 -257 -327 -310
        -523 l-27 -98 -1 -410 0 -410 26 -55 c38 -81 82 -126 161 -164 l71 -34 27 -86
        c16 -48 48 -121 72 -163 48 -86 174 -221 250 -268 34 -21 48 -37 48 -52 0 -25
        24 -19 -352 -88 -135 -24 -271 -54 -301 -65 -160 -60 -282 -187 -343 -358 -15
        -43 -30 -80 -34 -84 -3 -5 -72 59 -153 140 -199 201 -200 172 25 399 l173 173
        -305 305 -305 306 -221 -223 c-186 -188 -226 -233 -252 -288 -49 -102 -65
        -178 -60 -294 5 -112 26 -184 80 -272 21 -35 248 -269 657 -677 585 -582 631
        -625 695 -656 180 -85 399 -76 556 23 27 17 153 126 279 241 l230 210 -62 62
        -61 63 882 0 c485 0 882 3 882 8 0 26 -204 612 -231 664 -43 80 -146 183 -224
        225 -83 43 -133 56 -420 108 -332 60 -305 53 -304 78 0 15 23 39 76 77 42 30
        95 78 120 106 l44 52 117 4 c94 3 125 8 157 25 51 27 91 67 119 118 21 40 21
        45 21 630 0 530 -2 598 -18 673 -89 413 -382 723 -787 833 -57 16 -113 21
        -235 24 -88 2 -173 1 -190 -2z m308 -168 c327 -57 602 -289 708 -598 40 -117
        49 -188 49 -399 l0 -186 -40 15 c-39 16 -40 17 -40 65 l0 48 -95 0 c-243 0
        -472 99 -654 284 l-74 75 -88 -83 c-198 -189 -401 -276 -644 -276 l-95 0 0
        -48 c0 -48 -1 -49 -41 -65 l-41 -16 5 232 c5 259 11 292 78 435 120 258 355
        449 620 506 143 30 228 33 352 11z m-78 -988 c130 -107 318 -192 480 -217 44
        -7 86 -14 93 -16 9 -3 12 -62 12 -256 0 -272 -7 -323 -54 -430 l-26 -58 -287
        -2 -288 -3 0 -80 0 -80 215 -5 215 -5 -47 -33 c-71 -49 -163 -90 -246 -108
        -99 -22 -252 -15 -342 15 -203 69 -358 228 -427 436 -25 76 -26 92 -31 339 -5
        283 -6 276 54 276 48 0 212 44 294 80 77 32 251 142 284 179 11 12 23 21 28
        21 5 0 37 -24 73 -53z m-895 -489 l0 -141 -26 24 c-14 13 -32 36 -40 51 -17
        32 -18 111 -3 141 15 28 50 67 61 67 4 0 8 -64 8 -142z m1712 81 c35 -65 20
        -146 -36 -198 l-26 -24 0 142 0 143 22 -14 c12 -8 30 -30 40 -49z m18 -444 c0
        -67 -3 -79 -25 -100 -19 -20 -34 -25 -73 -25 l-49 0 23 68 c13 37 24 74 24 82
        0 13 58 43 93 49 4 0 7 -33 7 -74z m-2580 -460 l-45 -45 -190 190 -189 190 44
        45 45 45 190 -190 190 -190 -45 -45z m-194 -200 c-52 -75 -58 -173 -17 -252
        30 -58 667 -688 716 -709 77 -32 196 -14 250 36 21 19 21 19 210 -171 l190
        -190 -52 -49 c-29 -27 -79 -61 -110 -77 -54 -26 -67 -28 -173 -28 -188 0 -135
        -42 -847 669 -667 666 -649 645 -675 786 -22 118 19 250 109 350 l46 52 189
        -190 190 -189 -26 -38z m1874 42 c81 0 144 6 180 16 30 8 56 14 57 13 1 -1
        -53 -57 -120 -124 l-122 -122 -124 124 -124 124 64 -16 c42 -10 106 -16 189
        -15z m-188 -274 l178 -178 179 179 179 179 314 -57 c253 -46 325 -62 374 -86
        68 -33 130 -88 169 -150 22 -34 155 -406 155 -432 0 -4 -384 -8 -853 -8 l-852
        0 -155 155 c-85 85 -159 155 -163 155 -5 0 -73 -58 -151 -128 -226 -206 -234
        -212 -268 -212 -26 0 -48 17 -133 101 l-103 101 39 115 c44 131 83 198 143
        248 78 63 135 81 441 139 160 29 299 54 310 55 13 1 80 -59 197 -176z m-154
        -890 l-53 -53 -190 190 -190 191 54 50 54 51 188 -188 189 -189 -52 -52z"/>
        <path d="M4576 3558 c-8 -13 -73 -121 -145 -241 l-130 -217 42 -26 c23 -14 52
        -32 64 -40 12 -8 26 -14 30 -14 5 0 39 52 77 116 46 76 72 111 77 102 4 -7 19
        -56 33 -108 170 -626 48 -1299 -329 -1825 -32 -44 -59 -85 -62 -91 -4 -10 102
        -104 118 -104 12 0 123 159 191 273 214 360 320 751 321 1177 0 230 -33 462
        -93 659 -11 36 -18 66 -17 68 3 2 90 -49 204 -118 l32 -20 42 71 c23 39 40 72
        38 74 -5 5 -433 262 -459 276 -16 8 -22 6 -34 -12z"/>
        </g>
      </svg>
    )
    const Icon4 = () =>(
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" className='max-w-12 md:max-w-14'
        viewBox="0 0 512.000000 512.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="#0773b3" stroke="none">
        <path d="M165 4761 c-51 -23 -101 -79 -114 -128 -16 -55 -15 -1149 0 -1194 18
        -51 55 -97 102 -122 42 -22 48 -22 547 -27 l505 -5 268 -192 c291 -209 310
        -218 355 -170 21 22 22 32 22 195 l0 172 63 0 c93 0 135 16 188 69 70 70 70
        71 67 712 l-3 554 -28 48 c-15 26 -47 60 -69 75 l-42 27 -910 2 c-864 3 -913
        2 -951 -16z m1830 -165 c14 -20 15 -90 13 -570 -3 -529 -4 -548 -22 -562 -14
        -10 -51 -14 -132 -14 -160 0 -158 2 -162 -174 -2 -75 -5 -136 -7 -136 -2 0
        -101 70 -220 155 l-216 155 -502 0 c-439 0 -505 2 -525 16 l-22 15 0 554 c0
        490 2 555 16 569 14 14 108 16 889 16 l875 0 15 -24z"/>
        <path d="M1035 4561 c-94 -24 -164 -81 -205 -165 -54 -109 -42 -224 32 -328
        16 -23 19 -33 9 -36 -7 -2 -40 -25 -74 -51 -109 -83 -188 -228 -191 -349 -1
        -60 1 -65 32 -93 l32 -29 436 0 436 0 29 29 c25 26 29 37 29 86 0 138 -96 299
        -232 386 l-48 31 31 38 c87 108 77 276 -23 385 -73 80 -197 121 -293 96z m135
        -173 c159 -82 56 -325 -114 -268 -42 14 -82 57 -95 105 -24 86 50 183 139 185
        14 0 46 -10 70 -22z m75 -492 c85 -39 184 -153 185 -213 0 -10 -73 -13 -330
        -13 -181 0 -330 3 -330 6 0 3 12 29 26 58 83 167 281 239 449 162z"/>
        <path d="M3455 4684 c-354 -52 -591 -156 -791 -347 -166 -156 -278 -353 -338
        -592 -39 -157 -49 -245 -50 -470 -2 -246 5 -222 -129 -400 -152 -202 -224
        -398 -167 -455 20 -20 24 -21 123 -40 l57 -11 0 -113 c0 -99 2 -115 20 -134
        11 -12 32 -25 45 -28 14 -3 25 -9 25 -12 0 -4 -19 -24 -41 -44 -41 -38 -42
        -39 -36 -94 4 -41 17 -74 46 -122 46 -77 71 -137 101 -240 18 -62 26 -76 58
        -97 84 -55 184 -54 432 5 171 41 232 47 265 26 14 -9 25 -26 25 -39 0 -12 -22
        -87 -49 -167 -64 -187 -80 -253 -88 -349 -6 -76 -5 -80 20 -105 l26 -26 854 0
        854 0 23 25 c33 35 24 85 -59 332 -110 329 -139 463 -148 694 l-6 146 130 129
        c257 255 391 526 439 884 90 679 -262 1319 -854 1551 -190 74 -285 91 -537 94
        -121 2 -233 1 -250 -1z m385 -548 l0 -393 -44 -5 c-92 -11 -179 -90 -206 -188
        -5 -19 -10 -159 -10 -311 0 -317 5 -348 71 -423 23 -26 40 -48 38 -50 -2 -2
        -95 -58 -206 -124 l-203 -121 -66 35 c-52 27 -77 34 -123 34 -164 0 -285 -119
        -285 -279 1 -240 279 -367 459 -209 66 58 95 123 95 213 l0 70 78 45 c42 24
        173 102 291 172 188 112 220 128 258 128 110 0 203 53 247 141 l26 53 0 304
        c0 205 -4 318 -12 344 -14 49 -76 120 -123 142 -19 10 -54 20 -78 24 l-42 8
        -3 377 -2 377 27 -6 c57 -14 200 -67 258 -97 216 -108 410 -306 523 -532 43
        -87 89 -222 114 -338 32 -147 31 -416 -1 -567 -66 -307 -225 -575 -451 -761
        -41 -33 -81 -68 -87 -77 -16 -20 -18 -261 -3 -382 21 -163 61 -333 129 -541
        l69 -209 -725 0 -726 0 7 43 c4 23 31 114 61 202 62 186 71 234 55 296 -17 63
        -52 103 -115 135 -52 25 -62 26 -138 21 -45 -4 -138 -20 -207 -37 -171 -41
        -272 -55 -298 -41 -11 6 -24 29 -31 56 -19 74 -49 148 -86 210 l-36 59 44 45
        c54 55 67 80 67 121 0 44 -31 84 -85 109 l-45 21 0 114 c0 143 -10 160 -109
        178 -35 7 -65 17 -68 24 -8 21 53 128 137 240 149 198 166 245 156 423 -4 66
        -3 171 4 244 51 597 394 973 965 1061 50 8 168 14 263 15 l172 1 0 -394z m234
        -582 l26 -27 0 -288 0 -288 -24 -28 c-24 -27 -27 -28 -139 -31 -130 -4 -166 7
        -186 56 -9 20 -11 108 -9 306 l3 278 28 24 c26 23 36 24 151 24 120 0 124 -1
        150 -26z m-934 -1139 c42 -22 60 -53 60 -106 0 -127 -167 -161 -224 -46 -49
        101 63 204 164 152z"/>
        <path d="M1443 2028 l-268 -193 -505 -5 c-499 -5 -505 -5 -547 -27 -47 -25
        -84 -71 -102 -122 -8 -24 -11 -204 -11 -605 0 -531 2 -574 19 -611 22 -50 79
        -101 128 -115 27 -8 308 -10 939 -8 l900 3 42 27 c22 15 54 49 69 75 l28 48 3
        554 c3 641 3 642 -67 712 -53 53 -95 69 -188 69 l-63 0 0 173 c0 168 -1 174
        -23 195 -48 45 -66 36 -354 -170z m219 -184 c4 -176 2 -174 162 -174 81 0 118
        -4 132 -14 18 -14 19 -32 19 -569 0 -455 -2 -557 -14 -570 -12 -16 -87 -17
        -887 -17 -780 0 -874 2 -888 16 -14 14 -16 79 -16 569 l0 554 22 15 c20 14 86
        16 525 16 l502 0 213 154 c117 85 216 155 220 155 3 1 8 -60 10 -135z"/>
        <path d="M354 1506 c-48 -21 -61 -89 -24 -126 20 -20 33 -20 744 -20 l725 0
        20 26 c28 35 26 67 -3 101 l-24 28 -704 2 c-575 2 -709 0 -734 -11z"/>
        <path d="M332 1140 c-28 -26 -29 -79 -3 -111 l19 -24 717 -3 716 -2 30 29 c36
        36 38 73 4 106 l-24 25 -719 0 c-709 0 -719 0 -740 -20z"/>
        <path d="M336 789 c-20 -16 -26 -29 -26 -59 0 -30 6 -43 26 -59 26 -21 34 -21
        731 -21 598 0 708 2 732 15 48 24 56 81 16 120 l-24 25 -714 0 c-707 0 -715 0
        -741 -21z"/>
        </g>
      </svg>
    )

    const stats = [
        { id: 1, name: 'CURRENT PIZZA LOCATIONS', value: 1100, icon: <Icon0 /> },
        { id: 2, name: 'CALLS PER MONTH', value: 1000000, icon: <Icon1 /> },
        { id: 3, name: 'ORDERS PER WEEK', value: 231000, icon: <Icon2 /> },
        { id: 4, name: 'PROFESSIONAL CALL AGENTS', value: 950, icon: <Icon3 /> },
        { id: 5, name: 'CALL CENTERS FOR REDUNDANCY', value: 4, icon: <Icon4 /> },
      ]

      const style = {
        py: 0,
        
        height: '1px',
        width: '80%',
        backgroundColor: '#7a7777',
        // maxWidth: 360,
        // border: '1px solid #9e9c9c',
        margin: 'auto',
        borderRadius: 1,
        border: 'none',
      };

  return (
    <div className='py-20 pt-10 text-white mt-12'
    style={{
        backgroundImage: `url(${kanekt365CounterBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'}}>
        
      <div className="mx-auto max-w-7xl px-10 mb-10">
        <dl className="grid grid-cols-1 gap-x-2 gap-y-16 text-center md:grid-cols-5">
          {stats.map((stat) => (
            <div key={stat.id} className="mx-auto flex max-w-xs flex-col gap-y-4">

              <dt className="text-base text-left font-semibold leading-7 gap-x-4 flex items-center justify-center flex-nowrap">
                {stat.icon} 
                {stat.name}
              </dt>

              <dd className="order-first tracking-tight text-[48px] font-bold">

                <div style={{ fontFamily: 'Barlow Condensed, sans-serif'}}>
                  <CountUp end={stat.value} duration={2} separator="," suffix="+" />
                </div>

              </dd> 
            </div>
          ))}
        </dl>
      </div>
        <Divider sx={style} /> 

       <div className='hidden md:block'>
          <h2 className="text-2xl mt-4 font-normal text-white text-center">
            Watch the Kanekt 365 overview video that demonstrates
          </h2>

          <h1 className="mt-1 font-bold text-white text-center" style={{fontSize: '42px'}} >
            ALL OUR SERVICES AND SEE YOUR ROI
          </h1>
       </div>

        <div className='md:hidden'>
          <h1 className="text-3xl mt-4 font-semibold text-white text-center pt-5 p-2">
            Watch the Kanekt 365 overview video to learn about everything our call centers have to offer and see your ROI!
          </h1>
        </div>

        <div className='mt-5 flex items-center justify-center'>
          <Link to='/' className='flex items-center py-4 px-3 border-none rounded-md text-white text-sm font-semibold
            bg-[#0773B3] hover:bg-[#282D47] transition duration-500'>
               <svg className='h-4 w-4 mr-2' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor">
                <path d="M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9l0 176c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"/>
               </svg>
              NO RISK FREE TRIAL
          </Link>
        </div>
    </div>
  )
}

export default CounterSection